export const SETMEMBER = 'SETMEMBER';